import React, { useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ArrowDown from '@material-ui/icons/ExpandMoreOutlined';
import Typography from '@material-ui/core/Typography';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import _ from 'lodash';
import '../css/quotes.css';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
        '& .MuiPaper-elevation1': {
            boxShadow: 'none !important'
        },
        '& .MuiListItem-root': {
            padding: '0 !important'
        },
        '& .MuiPaper-root': {
            borderRadius: 0
        },
        '& .MuiTable-root:hover': {
            background: '#eeeeee'
        },
        '& .MuiTableCell-root': {
            fontFamily: 'Roboto, sans-serif'
        }
    },
    typography: {
      padding: theme.spacing(2),
    },
    iconButton: {
        position: 'absolute',
        top: 5,
        right: 5
    },
    icon: {
        color: '#f19031'
    },
    colorCode: {
        height: 5,
        width: '90%',
        display: 'inline-block',
        borderRadius: 200
    },
    tooltip: {
        fontSize: 16,
        backgroundColor: '#ffffff',
        maxWidth: 220,
        color: 'rgba(0, 0, 0, 0.87)',
        position: 'relative',
        border: '2px solid'
    },
    tooltipArrow: {
        color: '#ffffff'
    },
    toolTipInner: {
        backgroundColor: '#ffffff'
    }
}));

const ColorCodeToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#ffffff',
    padding: '30px 15px',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(18),
    border: '2px solid',
    borderColor: props => props.color
  },
}))(Tooltip);

function QuoteDropdown(props) {

    const classes = useStyles(props);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const states = useSelector(state => {
        return state.globalStates
    })

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };

    const handleClickAway = () => {
        setOpen(false)
    }

    const handleProviderClick = (event) => {
        event.preventDefault();
        const quotes = states.quotes && _.isArray(states.quotes) ? states.quotes : [];
        const providerId = event.currentTarget.id
        const provider = _.find(quotes, ['provider_id', providerId])
        const newSelected = [ ...states.selected_quotes ];
        newSelected.splice(props.index, 1, provider);
        dispatch({
            type: `UPDATE_SELECTED_QUOTES`,
            payload: newSelected
        })
        setOpen(false)
    }

    const listProviders = () => {
        const options = props.providers.sort(function(a, b) {
            return parseFloat(a.total_premium) - parseFloat(b.total_premium);
        }).map((provider, index) => {
            const accreditation = provider.is_accredited.accreditation;
            const color = provider.is_accredited.color;
            const desc = provider.is_accredited.accreditation_desc;
            return(
                <List key={ `provider-option-${ index }` } component="list" className={classes.root} aria-label="provider options">
                    <ListItem onClick={ handleProviderClick } button id={ provider.provider_id }>
                        <TableContainer component={Paper}>
                            <Table aria-label="coverage-table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell component="td" scope="row" width={ 25 }>
                                            <ColorCodeToolTip
                                                classes={{ tooltip: classes.tooltipArrow }}
                                                color={ color }
                                                arrow
                                                placement="top-start"
                                                title={
                                                <React.Fragment>
                                                    <div className={ classes.toolTipInner }>
                                                        <span style={{ fontWeight: 700 }}>{ accreditation }</span> - <span>{ desc }</span>
                                                    </div>
                                                </React.Fragment>
                                                }
                                            >
                                                <span style={{ background: color }} className={ classes.colorCode }></span>
                                            </ColorCodeToolTip>
                                        </TableCell>
                                        <TableCell component="td" scope="row" align={ `left` } style={{ fontWeight: 700 }}>{ `${ _.truncate(provider.product_name, { length: 20 }) }` }</TableCell>
                                        <TableCell component="td" scope="row" align={ 'right' } style={{ fontWeight: 700 }}>{ `P ${ (Math.round(provider.total_premium / 100)).toLocaleString() }` }</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>  
                    </ListItem>
                </List>
            )
        })
        return options;
    }

    return(
        <ClickAwayListener onClickAway={handleClickAway}>

        <Grid container justify="right">
            <Popper open={open} anchorEl={anchorEl} placement={ `bottom-end` } transition>
                {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                    <Paper elevation={3}>
                        {/* <Typography className={classes.typography}>The content of the Popper.</Typography> */}
                        { listProviders() }
                    </Paper>
                </Fade>
                )}
            </Popper>
            <Grid item>
                <IconButton
                    aria-label="expand"
                    onClick={ handleClick }
                    className={ classes.iconButton }
                >
                    <ArrowDown fontSize="large" className={ classes.icon }/>
                </IconButton>
            </Grid>
        </Grid>

        </ClickAwayListener>
    )
}

export default QuoteDropdown;